import { render, staticRenderFns } from "./returnOrderAdd.vue?vue&type=template&id=56f64a43&scoped=true&"
import script from "./returnOrderAdd.vue?vue&type=script&lang=js&"
export * from "./returnOrderAdd.vue?vue&type=script&lang=js&"
import style0 from "./returnOrderAdd.vue?vue&type=style&index=0&id=56f64a43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f64a43",
  null
  
)

export default component.exports